import { render, staticRenderFns } from "./booking-information.vue?vue&type=template&id=8b582f98&"
import script from "./booking-information.vue?vue&type=script&lang=js&"
export * from "./booking-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports